import React from 'react';
import { IconContainer } from './IconContainer';

const SortArrow = ({ rotate, ...props }) => {
    return (
        <IconContainer ariaLabel="sort-arrow" rotate={rotate} {...props}>
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.66664 10.7813L12.2426 7.20529L13.1853 8.14796L7.99997 13.3333L2.81464 8.14796L3.7573 7.20529L7.3333 10.7813V2.66663H8.66664V10.7813Z" fill="#8898B2"/>
            </svg>
        </IconContainer>
    )
}

export { SortArrow };